<template>
  <vue-perfect-scrollbar class="scroll-area">
    <div class="flex-1 flex flex-col db">
      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
          <statistics-card-line
            icon="UsersIcon"
            statistic="2 drivers"
            statisticTitle="Drivers Performance (M)"
            :chartData="[
              {
                name: 'Trip Completion Percentage',
                data: [28, 40, 36, 52, 38, 60, 55, 10],
              },
            ]"
            type="area"
          />
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
          <statistics-card-line
            icon="DollarSignIcon"
            statistic="145 trips"
            statisticTitle="PO/Invoice Amount Processed (M)"
            :chartData="[
              {
                name: 'Revenue',
                data: [3500, 2750, 4000, 3000, 3500, 3000, 4500],
              },
            ]"
            color="success"
            type="area"
          />
        </div>

        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
          <statistics-card-line
            icon="BellIcon"
            statistic="1399 issues"
            statisticTitle="Incomplete Trips/Alerts"
            :chartData="[
              {
                name: 'Alerts',
                data: [10, 15, 7, 12, 3, 16],
              },
            ]"
            color="danger"
            type="area"
          />
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
          <statistics-card-line
            icon="ApertureIcon"
            statistic="17 times"
            statisticTitle="Driver/Vehicle Incident"
            :chartData="[
              {
                name: 'Incident Count',
                data: [10, 15, 8, 15, 7, 12, 8],
              },
            ]"
            color="warning"
            type="area"
          />
        </div>
      </div>

      <div class="vx-row"></div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-base">
          <vx-card>
            <vx-card
              slot="no-body"
              class="text-center bg-primary-gradient greet-user"
            >
              <h1 class="mb-6 text-white">0 Trip Alerts</h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
                You have <strong>0</strong> items requiring attention.
              </p>
            </vx-card>
            <h2 class="mb-1 font-bold">Trip Stats</h2>
            <vs-divider class="my-6"></vs-divider>
            <div class="vx-row">
              <div class="vx-col w-1/2 mb-3">
                <p>UPCOMING: 2 TRIPS</p>
                <vs-progress
                  class="block mt-1"
                  :percent="100"
                  color="success"
                ></vs-progress>
              </div>
              <div class="vx-col w-1/2 mb-3">
                <p>DELAYED: 0 TRIPS</p>
                <vs-progress
                  class="block mt-1"
                  :percent="100"
                  color="warning"
                ></vs-progress>
              </div>
              <div class="vx-col w-1/2 mb-3">
                <p>CANCELLED: 0 TRIPS</p>
                <vs-progress
                  class="block mt-1"
                  :percent="100"
                  color="danger"
                ></vs-progress>
              </div>
              <div class="vx-col w-1/2 mb-3">
                <p>RESCHEDULED: 0 TRIPS</p>
                <vs-progress
                  class="block mt-1"
                  :percent="100"
                  color="primary"
                ></vs-progress>
              </div>
            </div>
          </vx-card>
        </div>

        <div class="vx-col w-full md:w-1/2 mb-base">
          <vx-card title="Activity Timeline">
            <p>TARGET DELIVERY KPI FOR AUGUST '22</p>
            <vue-apex-charts
              type="radialBar"
              height="250"
              :options="analyticsData.goalOverviewRadialBar.chartOptions"
              :series="[38]"
            />
            <br />
            <br />
            <ul class="activity-timeline">
              <li>
                <div class="timeline-icon bg-primary">
                  <feather-icon
                    icon="PlusIcon"
                    svgClasses="text-white stroke-current w-5 h-5"
                  ></feather-icon>
                </div>
                <div class="timeline-info">
                  <p class="font-semibold">No recent activity.</p>
                </div>
              </li>
            </ul>
          </vx-card>
        </div>
      </div>
      <!-- CARD 1: CONGRATS -->

      <br />
      <vx-card>
        <vs-tabs>
          <vs-tab label="Drivers" icon-pack="feather" icon="icon-user">
            <Driver></Driver>
          </vs-tab>

          <vs-tab label="Transporters" icon="icon-aperture" icon-pack="feather">
            <Transporter></Transporter>
          </vs-tab>

          <vs-tab label="Clients" icon="icon-user" icon-pack="feather">
            <Client></Client>
          </vs-tab>

          <vs-tab label="Trips" icon="icon-user" icon-pack="feather">
            <Trip></Trip>
          </vs-tab>

          <!--
       <vs-tab label="Service Schedule" icon-pack="feather" icon="icon-calendar">
      <Calendar></Calendar>
     </vs-tab>


     <vs-tab label="Fuel Receipts" icon="local_gas_station" >
       <FuelReceipt></FuelReceipt>
     </vs-tab>
-->
        </vs-tabs>
        <br />
        <br />
        <br />
        <br />
        <br />
      </vx-card>
    </div>
  </vue-perfect-scrollbar>
</template>

<script>
import Trip from './Trip.vue';
import Client from './Client.vue';
import Transporter from './Transporter.vue';
import VueApexCharts from 'vue-apexcharts';
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue';
import analyticsData from './analyticsData.js';
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue';
import FuelReceipt from './FuelReceipt.vue';
import Driver from './Driver.vue';

export default {
  data() {
    return {
      analyticsData,
      isImp: false,
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      show: false,
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      nextNum: 10,
      tableList: [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot',
      ],
      users: [
        {
          orderNo: 879985,
          status: 'Moving',
          statusColor: 'success',
          operator: 'Cinar Knowles',
          operatorImg: 'avatar-s-2.png',
          usersLiked: [
            { name: 'Vennie Mostowy', img: 'avatar-s-5.png' },
            { name: 'Elicia Rieske', img: 'avatar-s-7.png' },
            { name: 'Julee Rossignol', img: 'avatar-s-10.png' },
            { name: 'Darcey Nooner', img: 'avatar-s-8.png' },
          ],
          location: 'Anniston, Alabama',
          distance: '130 km',
          distPercent: 80,
          startDate: '14:58 26/07/2018',
          estDelDate: '28/07/2018',
        },
        {
          orderNo: 156897,
          status: 'Pending',
          statusColor: 'warning',
          operator: 'Britany Ryder',
          operatorImg: 'avatar-s-4.png',
          usersLiked: [
            { name: 'Trina Lynes', img: 'avatar-s-1.png' },
            { name: 'Lilian Nenez', img: 'avatar-s-2.png' },
            { name: 'Alberto Glotzbach', img: 'avatar-s-3.png' },
          ],
          location: 'Cordova, Alaska',
          distance: '234 km',
          distPercent: 60,
          startDate: '14:58 26/07/2018',
          estDelDate: '28/07/2018',
        },
        {
          orderNo: 568975,
          status: 'Moving',
          statusColor: 'success',
          operator: 'Kishan Ashton',
          operatorImg: 'avatar-s-1.png',
          usersLiked: [
            { name: 'Lai Lewandowski', img: 'avatar-s-6.png' },
            { name: 'Elicia Rieske', img: 'avatar-s-7.png' },
            { name: 'Darcey Nooner', img: 'avatar-s-8.png' },
            { name: 'Julee Rossignol', img: 'avatar-s-10.png' },
            { name: 'Jeffrey Gerondale', img: 'avatar-s-9.png' },
          ],
          location: 'Florence, Alabama',
          distance: '168 km',
          distPercent: 70,
          startDate: '14:58 26/07/2018',
          estDelDate: '28/07/2018',
        },
        {
          orderNo: 245689,
          status: 'Canceled',
          statusColor: 'danger',
          operator: 'Anabella Elliott',
          operatorImg: 'avatar-s-6.png',
          usersLiked: [
            { name: 'Vennie Mostowy', img: 'avatar-s-5.png' },
            { name: 'Elicia Rieske', img: 'avatar-s-7.png' },
          ],
          location: 'Clifton, Arizona',
          distance: '125 km',
          distPercent: 95,
          startDate: '14:58 26/07/2018',
          estDelDate: '28/07/2018',
        },
      ],
    };
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    FuelReceipt,
    Driver,
    Transporter,
    Client,
    Trip,
  },
};
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .db {
      overflow-y: scroll;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
